import React, { useContext } from "react";
import { Mention, MentionsInput } from "react-mentions";
import { GrigoraDashboardContext } from "../dashboard/context";
import classNames from "classnames";
import "./mentions.scss";
import Avatar from "./avatar";
import { AccountContext } from "../account/account";

const GrigoraMentionsInput = ({
  value,
  onChange = () => {},
  disabled = false,
  className,
  submitOnEnter,
  onSubmit,
}) => {
  const { project, projectMembers } = useContext(GrigoraDashboardContext) ?? {};
  const { userAttributes } = useContext(AccountContext) ?? {};

  var classes = classNames("grigora-mentions-input", className);
  return (
    <div className={classes}>
      <MentionsInput
        disabled={disabled}
        className="input-field"
        value={value}
        onChange={onChange}
        style={{
          control: {
            fontSize: 12,
            fontWeight: "normal",
            padding: "10px",
          },
          "&multiLine": {
            control: {
              minHeight: disabled ? undefined : 63,
              padding: "9px",
            },
            highlighter: {
              border: "0px solid transparent",
              cursor: disabled ? undefined : "text",
            },
            input: {
              padding: "9px",
              outline: "none",
              // fontWeight: "300",
            },
          },
          suggestions: {
            borderRadius: "21px",
            top: "12px",
            backgroundColor: "white",
            list: {
              fontSize: 12,
            },
            item: {
              padding: "10px 15px",
              borderBottom: "1px solid #F2F2F2",
              "&focused": {
                color: "var(--color-ui-blue)",
              },
            },
          },
        }}
        onKeyDown={(e) => {
          if (!submitOnEnter) return;

          // Submit on enter
          if (!e.shiftKey && e.keyCode === 13) {
            e.preventDefault();
            onSubmit && onSubmit();
          }
        }}
      >
        <Mention
          trigger="@"
          data={Object.keys(projectMembers || {})
            .filter((userid) => userid !== userAttributes?.sub)
            .map((item) => {
              return {
                id: item,
                display: projectMembers[item].name,
              };
            })}
          className={"mentions__mention"}
          renderSuggestion={(entry) => {
            return (
              <div className="flex items-center gap-[13px] text-grigora-base">
                <Avatar memberID={entry.id} size={24} />
                {entry.display}
              </div>
            );
          }}
          appendSpaceOnAdd={true}
        />
      </MentionsInput>
    </div>
  );
};

export default GrigoraMentionsInput;
